import { ContractLineValidator } from '@/services/validation/ContractLineValidator';
import { ContractLineBillingCycleOutput, VariableContractLineOutput } from '@/graphql/contracts/_generated_/contracts';
import { variableValidationSchema } from './variableValidationSchema';
import { bcValidationSchema } from './bcValidationSchema';

export const bcValidator = new ContractLineValidator<ContractLineBillingCycleOutput>(bcValidationSchema);
export const variableLinesValidator = new ContractLineValidator<VariableContractLineOutput>(variableValidationSchema);
